export default __webpack_public_path__ + "static/media/Graphik-Semibold-Web.06e7125f.woff";